import { render, staticRenderFns } from "./UserGroupesList.vue?vue&type=template&id=1d9bc68a&"
import script from "./UserGroupesList.vue?vue&type=script&lang=js&"
export * from "./UserGroupesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports